var render, staticRenderFns
import script from "./PlaceholderRect.vue?vue&type=script&lang=js"
export * from "./PlaceholderRect.vue?vue&type=script&lang=js"
import style0 from "./PlaceholderRect.vue?vue&type=style&index=0&id=373d41b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373d41b8",
  null
  
)

export default component.exports